import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import PageLoader from "../ui/PageLoader";

/**
 * App shell — fixed navbar, routed page content, footer and floating
 * WhatsApp button. `pt-24` offsets the fixed navbar. Lazy routes render the
 * PageLoader spinner while their chunk loads, keeping the chrome in place.
 */
const Layout = () => (
  <div className="flex min-h-screen flex-col overflow-x-hidden">
    <Navbar />
    <main className="flex-grow pt-24">
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </main>
    <Footer />
    <WhatsAppButton />
  </div>
);

export default Layout;
